export const HttpMethod = {
  Get: "GET",
  Post: "POST",
  Put: "PUT",
  Patch: "PATCH",
  Delete: "DELETE",
};

const ApiRoutes = {
  Auth: {
    Login: {
      Endpoint: "/auth/login",
      Method: HttpMethod.Post,
    },
  },
   Property: {
    Create: { Endpoint: "/admin/property/", Method: HttpMethod.Post },
    GetById: (id) => ({ Endpoint: `/admin/property/${id}`,Method: HttpMethod.Get }),
    List: { Endpoint: "/admin/property/list", Method:HttpMethod.Get },
    Update: (id) => ({ Endpoint: `/admin/property/${id}`, Method:HttpMethod.Patch }),
    Delete: (id) => ({ Endpoint: `/admin/property/${id}`, Method:HttpMethod.Delete }),
    UpdateStatus: (id) => ({
      Endpoint: `/admin/property/${id}/status`,
      Method:HttpMethod.Put,
    }),
  },
   PropertyImages: {
    UploadImages: (id) => ({
      Endpoint: `/admin/propertyAsset/${id}/images`,
      Method:HttpMethod.Post,
    }),
    UploadDocuments: (id) => ({
      Endpoint: `/admin/propertyAsset/${id}/documents`,
      Method:HttpMethod.Post,
    }),
    DeleteImage: (propertyId, imageId) => ({
      Endpoint: `/admin/propertyAsset/${propertyId}/images/${imageId}`,
      Method: HttpMethod.Delete,
    }),
    DeleteDocument: (propertyId, documentId) => ({
      Endpoint: `/admin/propertyAsset/${propertyId}/documents/${documentId}`,
      Method: HttpMethod.Delete,
    }),
    UpdateDocument: (propertyId, documentId) => ({
      Endpoint: `/admin/propertyAsset/${propertyId}/documents/${documentId}`,
      Method: HttpMethod.Patch,
    }),
    UpdateImage: (propertyId, imageId) => ({
      Endpoint: `/admin/propertyAsset/${propertyId}/images/${imageId}`,
      Method: HttpMethod.Patch,
    }),
  },
  

  

  KYC: {
    GetAll: { Endpoint: "/admin/kyc", Method: HttpMethod.Get },
    GetById: {
      Endpoint: (userId) => `/admin/kyc/${userId}`,
      Method: HttpMethod.Get,
    },
    Approve: {
      Endpoint: (userId) => `/admin/kyc/${userId}/approve`,
      Method: HttpMethod.Post,
    },
    Reject: {
      Endpoint: (userId) => `/admin/kyc/${userId}/reject`,
      Method: HttpMethod.Post,
    },
    Update: {
      Endpoint: `/admin/kyc/update`,
      Method: HttpMethod.Post,
    },
    GetDocument: {
      Endpoint: (imageId, userId) =>
        `/admin/kyc/document/${imageId}?userId=${userId}`,
      Method: HttpMethod.Get,
    },
    DownloadAll: {
      Endpoint: (userId) => `/admin/kyc/download-all/${userId}`,
      Method: HttpMethod.Get,
    },
  },

  Investment: {
    GetAll: { Endpoint: "/admin/investment/", Method: HttpMethod.Get },
    GetById: {
      Endpoint: (id) => `/admin/investment/${id}`,
      Method: HttpMethod.Get,
    },
    Approve: {
      Endpoint: (id) => `/admin/investment/${id}/approve`,
      Method: HttpMethod.Post,
    },
    Reject: {
      Endpoint: (id) => `/admin/investment/${id}/reject`,
      Method: HttpMethod.Post,
    },
  },
  Referral: {
    Overview: {
      Endpoint: "/admin/referral/overview",
      Method: HttpMethod.Get,
    },
    Earnings: {
      Endpoint: "/admin/referral/earnings",
      Method: HttpMethod.Get,
    },
    Payout: {
      Endpoint: "/admin/referral/payout-schedule",
      Method: HttpMethod.Post,
    },
    DistributeProfit: {
      Endpoint: "/admin/referral/distribute-profit",
      Method: HttpMethod.Post,
    },
  },
  Share: {
    List: {
      Endpoint: "/admin/share",
      Method: HttpMethod.Get,
    },
  },
  User: {
    List: {
      Endpoint: "/admin/user/list",
      Method: HttpMethod.Get,
    },
    GetById: {
      Endpoint: (id) => `/admin/user/${id}`,
      Method: HttpMethod.Get,
    },
    ToggleStatus: (id) => ({
      Endpoint: `/admin/user/${id}/toggle-status`,
      Method: HttpMethod.Put,
    }),
    Delete: (id) => ({
      Endpoint: `/admin/user/${id}`,
      Method: HttpMethod.Delete,
    }),
    SendCredentials: (id) => ({
      Endpoint: `/admin/user/${id}/send-credentials`,
      Method: HttpMethod.Post,
    }),
  },
  Contact: {
    List: {
      Endpoint: "/admin/contact/list",
      Method: HttpMethod.Get,
    },
    Delete: (id) => ({
      Endpoint: `/admin/contact/${id}`,
      Method: HttpMethod.Delete,
    }),
  },
  Role: {
    List: {
      Endpoint: "/admin/roles",
      Method: HttpMethod.Get,
    },
    Create: {
      Endpoint: "/admin/roles",
      Method: HttpMethod.Post,
    },
    AssignPermissions: {
      Endpoint: "/admin/roles/assign-permissions",
      Method: HttpMethod.Post,
    },
    AssignUserRoles: {
      Endpoint: "/admin/roles/assign-user-roles",
      Method: HttpMethod.Put,
    },
    ListPermissions: {
      Endpoint: "/admin/roles/permissions",
      Method: HttpMethod.Get,
    },
    CreatePermission: {
      Endpoint: "/admin/roles/permissions",
      Method: HttpMethod.Post,
    },
    SeedPermissions: {
      Endpoint: "/admin/roles/permissions/seed",
      Method: HttpMethod.Post,
    },
    GetRolePermissions: (id) => ({
      Endpoint: `/admin/roles/${id}/permissions`,
      Method: HttpMethod.Get,
    }),
    Update: (id) => ({
      Endpoint: `/admin/roles/${id}`,
      Method: HttpMethod.Patch,
    }),
    Delete: (id) => ({
      Endpoint: `/admin/roles/${id}`,
      Method: HttpMethod.Delete,
    }),
    UnassignUserRole: (userId, roleId) => ({
      Endpoint: `/admin/roles/user/${userId}/role/${roleId}`,
      Method: HttpMethod.Delete,
    }),
  },
};

export default ApiRoutes;
